import translations from "../translations"
import * as I18n from "../services/i18n"

export default class StantFormat
  @converteMoedaFloat = (valor) ->
    if valor == ''
      valor = 0
    else
      # Obter separadores do locale atual
      delimiter = I18n.t(translations(), 'number.currency.format.delimiter')
      separator = I18n.t(translations(), 'number.currency.format.separator')
      unit = I18n.t(translations(), 'number.currency.format.unit')

      # Remover prefixo de moeda (pode ser R$, $, €, etc)
      valor = valor.toString().replace(unit, '').trim()

      # Remover separadores de milhares
      delimiterRegex = new RegExp('\\' + delimiter, 'g')
      valor = valor.replace(delimiterRegex, '')

      # Substituir separador decimal por ponto
      valor = valor.replace(separator, '.')

      valor = parseFloat(valor)
    valor

  @converteFloatMoeda: (valor) ->
    # Obter configurações de formatação do locale atual
    delimiter = I18n.t(translations(), 'number.currency.format.delimiter')
    separator = I18n.t(translations(), 'number.currency.format.separator')
    unit = I18n.t(translations(), 'number.currency.format.unit')

    # Check if currency symbol should be hidden based on company settings
    hideCurrencySymbol = false
    companySettingsMeta = document.getElementById('js_company_settings')
    if companySettingsMeta
      hideCurrencySymbol = companySettingsMeta.dataset.hideCurrencySymbol == 'true'

    inteiro = null
    decimal = null
    c = null
    j = null
    aux = new Array
    valor = '' + valor
    c = valor.indexOf('.', 0)
#encontrou o ponto na string
    if c > 0
      #separa as partes em inteiro e decimal
      inteiro = valor.substring(0, c)
      decimal = valor.substring(c + 1, valor.length)
    else
      inteiro = valor
#pega a parte inteiro de 3 em 3 partes
    j = inteiro.length
    c = 0
    while j > 0
      aux[c] = inteiro.substring(j - 3, j)
      j -= 3
      c++
#percorre a string acrescentando o separador de milhares
    inteiro = ''
    c = aux.length - 1
    while c >= 0
      inteiro += aux[c] + delimiter
      c--
#retirando o ultimo separador e finalizando a parte inteiro
    inteiro = inteiro.substring(0, inteiro.length - 1)

    if isNaN(decimal) || decimal == null
      decimal = '00'
    else
      decimal = '' + decimal
      if decimal.length == 1
        decimal = decimal + '0'
    if hideCurrencySymbol
      valor = inteiro + separator + decimal
    else
      valor = unit + ' ' + inteiro + separator + decimal
    valor

  @convertCurrencyToFloat: (value) ->
    removed_currency = value
    .replace(/[^0-9,-]+/g, '')
    .replace(',', '.')

    return parseFloat(removed_currency)

  window.StantFormat = StantFormat
